import { useApiClient, useTranslation } from '@msdk/common'
import { MetadataSelectorDefinition } from '@msdk/definitions'
import React, { useEffect, useState } from 'react'

import { FieldProps } from '../../../models/form'
import { useEntryFromCollection } from '../../../state'
import { MetadataSelectorComponent } from './MetadataSelectorComponent'
import { NodeItem } from './node'
import { SourceHandler } from './source-handler'

export function MetadataSelector({ node, onChange, fieldArgs }: FieldProps) {
  const t = useTranslation()
  const apiClient = useApiClient()
  const currentEntity = useEntryFromCollection(node.value.entityId as string)
  const [nodes, setNodes] = useState<NodeItem[]>([])
  const formDef = node.value.formDefinition as MetadataSelectorDefinition

  useEffect(() => {
    if (currentEntity?.entity) {
      const fetch = async () => {
        const sourceHandler = new SourceHandler(t, apiClient, currentEntity.entity)
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const nodes = await sourceHandler.processSources(formDef.sources)
        setNodes(nodes)
      }
      fetch().catch(console.error)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentEntity])

  return <MetadataSelectorComponent node={node} nodes={nodes} onChange={onChange} fieldArgs={fieldArgs} />
}
